import classNames from 'classnames'
import { ReactSVG } from 'react-svg'

import { UserOrder } from '@shared/generated'
import Button from '@shared/ui/button'
import { formatDate } from '@shared/uttils/formatDate'

import styles from './styles.module.scss'

export default function OrderHeader ({
  data,
  isDetail,
  handleDetailClick,
}: {
  data: UserOrder;
  isDetail: boolean;
  handleDetailClick: () => void;
}) {
  return (
    <div className={styles.header}>
      <div className={styles.header__text}>
        <span className={styles.header__data}>
          {formatDate(data?.created_at)}
        </span>
        <span className={styles.header__address}> {data.address}</span>
      </div>
      <Button
        onClick={handleDetailClick}
        className={classNames(styles.header__button, {
          [styles['header__button--active']]: isDetail,
        })}
        theme="grey"
        size="small"
      >
        <ReactSVG src="/icons/arrow-right.svg" wrapper="span" />
      </Button>
    </div>
  )
}
